import $ from "jquery";

const screencheck = function (mediasize) {
  let screensize = window.matchMedia("(max-width:" + mediasize + "px)");
  return !!screensize.matches;
};

export const init = () => {
  let attempts = 0;

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      $(document).on("click touchend", "#menu", function () {
        var pageHeader = $("body:not(.flyout-header) .page-header");
        pageHeader.addClass("fixed");
        pageHeader.removeClass("navhide");
        $(this).next(".nav-container").addClass("nav-container-open");
        $(this).next(".nav-container").slideDown("normal");

        return !1;
      });
      $(".nav-container").on("click touchend", function (event) {
        if ($(window).width() < 768) event.stopPropagation();
      });
      $(".nav > li > a").on("click", function () {
        if (screencheck(1024) && $("body.youth").length < 1)
          return $(this).parent("li").find(".megamenu").is(":visible")
            ? ($(this).parent("li").find(".megamenu").slideUp("normal"),
              $(this).parent("li").removeClass("current"),
              $(".nav").removeClass("hovered"),
              !1)
            : ($(".megamenu").slideUp("normal"),
              $(".nav").removeClass("hovered"),
              $(".nav > li").removeClass("current"),
              $(".nav").addClass("hovered"),
              $(this).parent("li").addClass("current"),
              $(this).parent("li").find(".megamenu").slideDown("normal"),
              !1);
      });
      $(".close-menu").on("click touchend", function () {
        $(this).parents(".nav-container").slideUp("normal");
        $(this).parents(".nav-container").removeClass("nav-container-open");
        $("input").blur();
        return !1;
      });
      $(".menulines-button").on("click touchend", function () {
        if ($(".nav-container-open").length) {
          // console.log("--- open ---");
          $(this).parent().find(".nav-container").slideUp("normal");
          $(this)
            .parent()
            .find(".nav-container")
            .removeClass("nav-container-open");
          $("input").blur();
          return !1;
        }
      });
      $(".megamenu").on("click touchend", function (event) {
        event.stopPropagation();
      });
      $(document).on("click", function (e) {
        0 === $(e.target).parent(".nav > li > a").length &&
          ($(".megamenu").fadeOut("fast"),
          $(".nav").removeClass("hovered"),
          $(".nav > li").removeClass("current")),
          $("body:not(.flyout-header) .page-header").removeClass("fixed");
      });
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
